// Groups an exercise library into flat "optgroups" for native <select>
// pickers, ordered by muscle group first, then by main muscle within it.
// HTML <optgroup> has no real nesting support, so each optgroup's label
// combines both levels ("{muscleGroup} – {mainMuscle}") to fake the two-tier
// grouping RoutinePicker's custom-rendered tap list shows for real. Preserves
// first-appearance order at both levels; exercises with no targetMuscle/
// mainMuscle fall into an "Other" bucket at that level.
export const groupExercisesForSelect = (exerciseLibrary) => {
  const groups = new Map(); // muscle -> Map(main -> list)
  exerciseLibrary.forEach((ex) => {
    const muscle = ex.targetMuscle || "Other";
    const main = ex.mainMuscle || "Other";
    if (!groups.has(muscle)) groups.set(muscle, new Map());
    const subGroups = groups.get(muscle);
    if (!subGroups.has(main)) subGroups.set(main, []);
    subGroups.get(main).push(ex);
  });

  const optgroups = [];
  groups.forEach((subGroups, muscle) => {
    subGroups.forEach((list, main) => {
      optgroups.push({ key: `${muscle}::${main}`, label: `${muscle} – ${main}`, list });
    });
  });
  return optgroups;
};
